import { Message, MessageBox } from "element-ui";

export function showError(message: string, useHtml = false) {
  return MessageBox({ title: "错误", message: message, dangerouslyUseHTMLString: !!useHtml, type: "error" });
}

export function showWarning(message: string) {
  return Message({ message: message, type: "error" });
}

export function showSuccess(message: string) {
  return Message({ message: message, type: "success" });
}

export function showConfirm(message: string) {
  return MessageBox.confirm(message, {
    title: "提示",
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    dangerouslyUseHTMLString: true
  });
}
